import { createFileRoute } from "@tanstack/react-router";
import ResetPassword from "@/pages/ResetPassword";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Restablecer contraseña",
  "pt-BR": "Redefinir senha",
  "en": "Reset password",
  "en-EU": "Reset password",
};

export const Route = createFileRoute("/reset-password")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/reset-password", loaderData),
  component: ResetPassword,
});
